<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    [class.opened]="!isSidebarHidden()"
    [class.closed]="isSidebarHidden()"
    class="sidenav"
    disableClose
    mode="side"
    opened
    position="start">
    <app-org-left-sidebar (isSidebarHiddenOutput)="onSidebarToggle($event)"></app-org-left-sidebar>
  </mat-sidenav>
  <mat-sidenav-content class="layout-container" [style.margin-left]="isSidebarHidden() ? '7.8rem' : '24.6rem'">
    <div [style.width.%]="100"><router-outlet></router-outlet></div>
  </mat-sidenav-content>
</mat-sidenav-container>
